export type HeaderParse =
  | { ok: true; value: Record<string, string> | null }
  | { ok: false; message: string };

/**
 * Parse a "Headers (JSON)" textarea.
 *
 * Both service and webhook forms previously swallowed parse failures
 * (`catch { /* skip *\/ }`) and saved with headers silently dropped, then
 * reported success. This returns the failure so the caller can surface it.
 */
export function parseHeaders(raw: string): HeaderParse {
  const trimmed = raw.trim();
  if (!trimmed || trimmed === '{}') return { ok: true, value: null };

  let parsed: unknown;
  try {
    parsed = JSON.parse(trimmed);
  } catch (err) {
    return { ok: false, message: err instanceof Error ? err.message : 'Invalid JSON.' };
  }

  if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
    return { ok: false, message: 'Headers must be a JSON object, e.g. {"Accept": "application/json"}' };
  }

  const entries = Object.entries(parsed as Record<string, unknown>);
  const nonString = entries.find(([, v]) => typeof v !== 'string');
  if (nonString) {
    return { ok: false, message: `Header "${nonString[0]}" must have a string value.` };
  }

  return { ok: true, value: entries.length ? (parsed as Record<string, string>) : null };
}
